import React from 'react'
import './Home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import { faAnglesDown, faComputerMouse } from '@fortawesome/free-solid-svg-icons';
import About from '../About/About';
import Skills from '../Skills/Skills';
import Project from '../Project/Project';
import Contact from '../Contact/Contact';

const Home = () => {
  return (
    <>
      <div className='sections home-section'>
      <p className='home-title'>Hi, my name is</p>
      <h1 className='home-name'>Mohammed Saqib.</h1>
      <h2 className="home-tag-line">I design and develop web based components and systems.</h2>
      <p className="home-desc">I'm a frontend developer with basic knowledge in designing great User interface and develop real life interactions.</p>
      <a href="#contactSection" className="contact-btn">
        <p>Get In Touch</p>
        <FontAwesomeIcon className='paperPlane' icon={faPaperPlane}  size="2x"/>
      </a>
      <a href="#aboutSection" className="scroll-down">
      <FontAwesomeIcon className='computerMouse' icon={faComputerMouse} size="2x" />
      <p  className="scroll-text">Scroll Down</p>
      <FontAwesomeIcon className='angleDown' icon={faAnglesDown} size="2x" bounce id='aboutSection'/>
      </a>
      </div>
      <About />
      <Skills />
      <Project />
      <Contact />
    </>
  )
}

export default Home;